import apiService from './api.service';

/**
 * Сервис для работы с каталогом и категориями
 * Конвертировано из Angular CatalogService
 */
class CatalogService {
    /**
     * Получить атрибуты категории
     */
    async getCategoryAttrs(id: number): Promise<any> {
        return apiService.get(`/api/core/categories/${id}/attrs/`, {});
    }

    /**
     * Получить предков категории (breadcrumbs)
     */
    async getCategoryAncestors(id: number): Promise<any> {
        return apiService.get(`/api/core/categories/${id}/ancestors/`, {});
    }

    /**
     * Поиск категорий
     */
    async searchCategory(q: string): Promise<any[]> {
        return apiService.get('/api/core/categories/search/', { q });
    }

    /**
     * Поиск категорий по определенным ID
     */
    async searchSpecificCategories(q: string, ids: string): Promise<any[]> {
        return apiService.get('/api/core/categories/search_limit_ids/', { q, ids });
    }
    /**
     * Запрос корневых категорий
     */
    async getRootCategories(): Promise<any[]> {
        return apiService.get('/api/core/categories/root-nodes/?category_type=1', {});
    }

    /**
     * Получить дочерние категории
     */
    async getChildCategories(id: number): Promise<any[]> {
        return apiService.get(`/api/core/categories/${id}/children/`, {});
    }

    /**
     * Поиск категорий по названию продукта
     */
    async searchSpecificCategoriesByProductName(q: string, ids: string): Promise<any[]> {
        return apiService.get('/api/core/categories/search_by_product_name/', { q, ids });
    }
    /**
     * Поиск категорий по названию продукта
     */
    async searchCategoriesByProductName(q: string, ids: string): Promise<any[]> {
        return apiService.get('/api/core/categories/search/', { q, ids });
    }

    /**
     * Сгенерировать КОХ (код основных характеристик)
     */
    async generateMainAttributesCode(data: any): Promise<any> {
        return apiService.post('/sma/api/save_analysis', data);
    }
}

export default new CatalogService();
